import { AxiosInstance } from 'axios';

import { axios } from '../../../../api/axios-instance';
import { colorEndpoints } from '../../../../constants';
import { DeleteItemsInput } from '../../../../types/delete-items-input';
import { IColor, IColors } from '../../entities/color';
import { CreateColorInput } from '../../schemas/color.schema';

class ColorsApi {
  #requestInstance: AxiosInstance;

  constructor(axiosInstance: AxiosInstance) {
    this.#requestInstance = axiosInstance;
  }

  create = async (color: CreateColorInput): Promise<IColor> => {
    return this.#requestInstance.post(colorEndpoints.color, color);
  };

  getColors = async (): Promise<IColors> => {
    return this.#requestInstance.get(colorEndpoints.color);
  };

  deleteColor = async (id: number): Promise<void> => {
    return this.#requestInstance.delete(colorEndpoints.getColorById(id));
  };

  deleteManyColors = async (input: DeleteItemsInput): Promise<void> => {
    return this.#requestInstance.delete(colorEndpoints.color, { data: input });
  };

  getColorById = async (id: number): Promise<IColor> => {
    return this.#requestInstance.get(colorEndpoints.getColorById(id));
  };

  updateColor = async (color: IColor): Promise<IColor> => {
    return this.#requestInstance.patch(colorEndpoints.getColorById(+color?.id), {
      name: color?.name,
      color: color?.color,
    });
  };
}

export const colorsApi = new ColorsApi(axios);
